import produce from 'immer';

import {
  CREATE_CATEGORY_FAILURE,
  CREATE_CATEGORY_SUCCESS,
  EDIT_CATEGORY_SEQUENCE_FAILURE,
  EDIT_CATEGORY_SEQUENCE_SUCCESS,
  EDIT_CRM_CATEGORY_FAILURE,
  EDIT_CRM_CATEGORY_SUCCESS,
  EDIT_DEFAULT_RESOLUTION_TIME_FAILURE,
  EDIT_DEFAULT_RESOLUTION_TIME_SUCCESS,
  FETCH_CATEGORY_LIST_FAILURE,
  FETCH_CATEGORY_LIST_SUCCESS,
  FETCH_CRM_CATEGORY_FAILURE,
  FETCH_CRM_CATEGORY_SUCCESS,
  GET_DEFAULT_RESOLUTION_TIME_FAILURE,
  GET_DEFAULT_RESOLUTION_TIME_SUCCESS,
} from '@actions/category';

const initialState: ICategoryStore = {
  categories: null,
  currentCategory: null,
  error: null,
  resolveByDays: 7,
};

export default (state: ICategoryStore = initialState, action: any) =>
  produce(state, (draftState: ICategoryStore) => {
    switch (action.type) {
      case CREATE_CATEGORY_SUCCESS:
        draftState.categories = action.response;
        draftState.error = null;

        return;

      case FETCH_CATEGORY_LIST_SUCCESS:
      case EDIT_CATEGORY_SEQUENCE_SUCCESS:
        draftState.categories = action.response;
        draftState.error = null;

        return;

      case FETCH_CRM_CATEGORY_SUCCESS:
        draftState.currentCategory = action.response;
        draftState.error = null;

        return;

      case EDIT_CRM_CATEGORY_SUCCESS:
        draftState.error = null;

        return;

      case CREATE_CATEGORY_FAILURE:
      case FETCH_CATEGORY_LIST_FAILURE:
      case FETCH_CRM_CATEGORY_FAILURE:
      case EDIT_CRM_CATEGORY_FAILURE:
      case EDIT_CATEGORY_SEQUENCE_FAILURE:
      case GET_DEFAULT_RESOLUTION_TIME_FAILURE:
      case EDIT_DEFAULT_RESOLUTION_TIME_FAILURE:
        draftState.error = action.error;

        return;

      case EDIT_DEFAULT_RESOLUTION_TIME_SUCCESS:
      case GET_DEFAULT_RESOLUTION_TIME_SUCCESS:
        const { resolveByDays } = action.response;
        draftState.resolveByDays = resolveByDays;

        return;
    }
  });
